import Vuex from 'vuex';
import { createHelpers } from 'vuex-map-fields';

Vue.use(Vuex);
const { getFieldNotificaciones, updateFieldNotificaciones } = createHelpers({
  getterType: 'getFieldNotificaciones',
  mutationType: 'updateFieldNotificaciones',
});

export default {
  namespaced: true,
  state: {
    notificaciones: [],
  },
  getters: {
    getFieldNotificaciones,
  },
  mutations: {
    updateFieldNotificaciones,
  },
};
